// extracted by mini-css-extract-plugin
export const headBgColorExternal = "#ffffff";
export const headBgColorInternal = "#1c2234";
export const headBgColorShrunkSidebar = "#3c425a";
export const regular = "400";
export const medium = "500";
export const semibold = "600";
export const bold = "700";
export const sans = "'sans'";
export const serif = "'serif'";
export const atlasGrotesk = "'AtlasGrotesk'";
export const accountLinkageForm = "LinkageForm__accountLinkageForm__GMZc8";
export const timeoutWrapper = "LinkageForm__timeoutWrapper__5BeYu font-faces__sansRegular__c8KXl font-faces__sans__uCf65";
export const timeoutCopy = "LinkageForm__timeoutCopy__NyCxJ";
export const timeoutValue = "LinkageForm__timeoutValue__ZH2Rf";
export const fieldsContainer = "LinkageForm__fieldsContainer__tY23H";
export const logo = "LinkageForm__logo__LwLF0";
export const name = "LinkageForm__name__2a-vX font-faces__sansMedium__DqLMY font-faces__sans__uCf65";
export const instructions = "LinkageForm__instructions__P13ib font-faces__sansRegular__c8KXl font-faces__sans__uCf65";
export const fieldList = "LinkageForm__fieldList__Ot7kf";
export const fieldListItem = "LinkageForm__fieldListItem__R-f1d";
export const errorWrapper = "LinkageForm__errorWrapper__IDrWs";
export const buttonWrapper = "LinkageForm__buttonWrapper__J58Os";
export const secureLink = "LinkageForm__secureLink__IWjv4 font-faces__sansRegular__c8KXl font-faces__sans__uCf65";
export const secureIconWrapper = "LinkageForm__secureIconWrapper__QzH1Y";
export const forgetPassword = "LinkageForm__forgetPassword__tzM2A font-faces__sansRegular__c8KXl font-faces__sans__uCf65";
export const phoneNumber = "LinkageForm__phoneNumber__q9jDP font-faces__sansRegular__c8KXl font-faces__sans__uCf65";